import React, { SelectHTMLAttributes, useState } from "react";
import { iOpt, iPermissoesData, } from "../../Types/Types";
import { Select, Tag } from "antd";
import api from "../../helpers/axios";
import { ADMID } from "../utils/exportVariables";

type iProps = SelectHTMLAttributes<HTMLSelectElement> & {
    placeHolder?: string;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    value: string[] | null;
    setValue: Function;
    execOnChange?: Function;
    adm?:boolean;
}

export default function SelectPermissoes({ value, adm,label, disabled, setValue,execOnChange, ...rest }: iProps) {
    const [options, setOptions] = useState<iOpt[]>([]);

    React.useEffect(() => {
        api.get('/permissoes').then((response) => {
            const tempOpt = [] as iOpt[];
            (response.data as iPermissoesData[]).map(item => {
                tempOpt.push({
                    value: item._id.toString(),
                    label: item.nome.toString()
                })
            })
            setOptions(adm ? tempOpt : tempOpt.filter(item => item.value !== ADMID));
        });

    }, []);
    const handleChange = (value: string[]) => {
        console.log(`Selected: ${value}`);
        if(execOnChange){
            execOnChange(value);
        }
        setValue(value);
    };
    return (
        <div>
            {label ? (
                <label
                    className="block mb-2 text-sm text-navy-700 font-bold"
                >
                    {label}
                </label>
            ) : (
                ''
            )}
            <Select
                mode="multiple"
                allowClear
                size="large"
                placeholder="Permissões"
                // defaultValue={[]}
                onChange={handleChange}
                value={value}
                style={{ width: "100%" }}
                options={options}
            />
        </div>
    );
}
